import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { BillingSubscription } from 'apps/payment/subscription';
import { PaymentMethods } from 'apps/payment/method';
import { PaymentHistory } from 'apps/payment/history';

@inject('routerStore')
@observer
export class BillingSettings extends React.Component {
  render() {
    return (
      <React.Fragment>
        <BillingSubscription />
        <PaymentMethods />
        <PaymentHistory />
      </React.Fragment>
    );
  }
}

BillingSettings.propTypes = {
  routerStore: PropTypes.object,
};
